import { render, staticRenderFns } from "./LengthMeasurementViz.vue?vue&type=template&id=23887709&scoped=true"
import script from "./LengthMeasurementViz.vue?vue&type=script&lang=js"
export * from "./LengthMeasurementViz.vue?vue&type=script&lang=js"
import style0 from "./LengthMeasurementViz.vue?vue&type=style&index=0&id=23887709&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23887709",
  null
  
)

export default component.exports